import Api from "@/services/Api";

export default {
  createRoom(params, token) {
    return Api().post("/admin/create-room", params, {
      headers: { "x-access-token": token }
    });
  },
  changePassAccount(params, token) {
    return Api().post("/admin/update-password-user-dma", params, {
      headers: { "x-access-token": token }
    });
  },
  deleteAccount (params, token) {
    return Api().post("/admin/delete-user", params, {
      headers: { "x-access-token": token }
    });
  },
  deleteMultiParticipants(params, token) {
    return Api().post("/admin/delete-participants", params, {
      headers: { "x-access-token": token }
    });
  },
  deleteRoom(params, token) {
    return Api().post("/admin/delete-room", params, {
      headers: { "x-access-token": token }
    });
  },
  exportConferenceLog(params, token) {
    return Api().post("/mcu/export-conference-history", params, {
      headers: { "x-access-token": token }
    })
  },
  fetchAllParticipants(params, token) {
    return Api().post("/admin/allUsers", params, {
      headers: { "x-access-token": token }
    })
  },
  fetchAccountList (params, token) {
    return Api().post("/admin/list", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchDevices (params, token) {
    return Api().post("/admin/devices", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchDevicesByUser (params, token) {
    return Api().post("/user/devicesList", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchParticipantWithUserName (params, token) {
    return Api().post("/admin/user", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchRoomList (params, token) {
    return Api().post("/admin/rooms", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchTemplateAndPool(token) {
    return Api().post("/admin/fetch-template-pool", {}, {
      headers: { "x-access-token": token }
    });
  },
  getConferenceHistory(params, token) {
    return Api().post('/mcu/conference-history', params, {
      headers: { "x-access-token": token }
    })
  },
  getExecutiveAccounts(token) {
    return Api().post("/admin/get-executive-accounts", undefined, {
      headers: { "x-access-token": token }
    });
  },
  getExecutiveAccountStatus(token) {
    return Api().post('/admin/get-executive-account-status', undefined, {
      headers: { 'x-access-token': token }
    })
  },
  getLockedRMParties(token) {
    return Api().post("/admin/parties-locked", undefined, {
      headers: { "x-access-token": token }
    });
  },
  searchParticipantWithUserName (params, token) {
    return Api().post("/admin/search-participants", params, {
      headers: { "x-access-token": token }
    });
  },
  setExecutiveAccountStatus(params, token) {
    return Api().post('/admin/set-executive-account-status', params, {
      headers: { 'x-access-token': token }
    })
  },
  unlockRMParty(params, token) {
    return Api().post("/admin/parties-unlocked", params, {
      headers: { "x-access-token": token }
    });
  },
  updateAccount (params, token) {
    return Api().post("/admin/update", params, {
      headers: { "x-access-token": token }
    });
  },
  updateRoom(params, token) {
    return Api().post("/admin/update-room", params, {
      headers: { "x-access-token": token }
    });
  },
  downloadOutLog(token) {
    return Api().post("/admin/download-out-log", {}, {
      headers: { "x-access-token": token }
    });
  },
  downloadErrorLog(token) {
    return Api().post("/admin/download-error-log", {}, {
      headers: { "x-access-token": token }
    });
  },
};
